import { render, staticRenderFns } from "./KreatorkaRozwiazan.vue?vue&type=template&id=bf09b840&scoped=true&"
import script from "./KreatorkaRozwiazan.vue?vue&type=script&lang=js&"
export * from "./KreatorkaRozwiazan.vue?vue&type=script&lang=js&"
import style0 from "./KreatorkaRozwiazan.vue?vue&type=style&index=0&id=bf09b840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf09b840",
  null
  
)

export default component.exports